import React from "react";
import MacWithLogo from '../../../MacWithLogo';
import './index.css';

import ArrowUp from '../../../../pageComponent/ArrowUp';
import InstallButton from '../../../../pageComponent/InstallButton';

export default class MonitorModule extends React.Component {
  render() {
    return (
      <div className="module-wrapper monitor-module">
        <div className="module-container">
          <div className="arrow-overflow-handler">
            <div className="arrow-up-and-monitor-wrapper">
              <div className="arrow-up-and-monitor-container">
                <div className="arrow-up-container">
                  <ArrowUp />
                </div>
                <div className="monitor-module-mac-with-logo-container">
                  <MacWithLogo />
                </div>
              </div>
            </div>
          </div>
          <div className="monitor-module-text">
            <div className="main-text monitor-module-main-text">
              Find your dream apartment, without the fear of being priced out. 
            </div>
            <div className="sub-text monitor-module-sub-text">
              Search for your next home on Streeteasy or Zillow, we’ll tell you if it’s rent stabilized. 
            </div>
            <InstallButton className="monitor-module-install-button" />
          </div>
        </div>
      </div>
    );
  }
}
